
import { defineComponent, computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'primevue/dialog';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';
import {
  MigrationV5State,
  closeMigrationV5Modal,
  snoozeModal,
  startMigrationV5,
  redirectToV5,
} from '@/composables/migrationV5';
import { showToastError } from '@/helpers';

type StepKey = 'overview' | 'requirements' | 'confirm';

const STEPS: { key: StepKey; label: string }[] = [
  { key: 'overview', label: 'migrationV5.modal.stepper.overview' },
  { key: 'requirements', label: 'migrationV5.modal.stepper.requirements' },
  { key: 'confirm', label: 'migrationV5.modal.stepper.confirm' },
];

export default defineComponent({
  name: 'MigrationV5Modal',
  components: {
    Dialog,
    SpmButton,
  },

  setup() {
    const { t } = useI18n();
    const currentStep = ref<StepKey>('overview');
    const loading = ref(false);

    const visible = computed(() => MigrationV5State.modalOpen);
    const currentStepIndex = computed(() => STEPS.findIndex((s) => s.key === currentStep.value));

    const reset = () => {
      currentStep.value = 'overview';
      loading.value = false;
    };

    const goNext = () => {
      const i = currentStepIndex.value;
      if (i < STEPS.length - 1) currentStep.value = STEPS[i + 1].key;
    };

    const goBack = () => {
      const i = currentStepIndex.value;
      if (i > 0) currentStep.value = STEPS[i - 1].key;
    };

    const handleLater = () => {
      snoozeModal();
      closeMigrationV5Modal();
      reset();
    };

    const onDismiss = (next: boolean) => {
      if (next === false && !loading.value) {
        handleLater();
      }
    };

    const handleConfirm = async () => {
      loading.value = true;
      try {
        await startMigrationV5();
        redirectToV5();
      } catch (e) {
        loading.value = false;
        await showToastError('GENERIC_ERROR');
      }
    };

    return {
      t,
      steps: STEPS,
      currentStep,
      currentStepIndex,
      loading,
      visible,
      goNext,
      goBack,
      handleLater,
      handleConfirm,
      onDismiss,
    };
  },
});
